<template>
  <v-app class="font-lato">
    <div class="report-export-container position-relative">
      <RightSidebar />
      <ColumnDetail />
      <FooterAction />
      <Banner :banner="banner" />
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import RightSidebar from './RightSidebar.vue';
import FooterAction from './FooterAction.vue';
import ColumnDetail from './ColumnDetail.vue';
import Banner from '../../Banner.vue'

export default {
  components: {
    RightSidebar,
    FooterAction,
    ColumnDetail,
    Banner,
  },
  computed: {
    ...mapGetters({
      banner: 'reportList/banner',
    }),
  },
  beforeDestroy() {
    this.$store.commit('reportList/setAllReportFields', []);
  },
}


</script>

<style>
.report-export-container {
  height: calc(100vh - 58px);
  background-color: #f4f4f4;
  display: flex;
  width: 100%;
}
</style>